import SelectCompanyWithBusinessUnitInput from "../../components/SelectCompanyWithBusinessUnitInput";
import {Box, Checkbox, FormControlLabel, Button} from "@mui/material";
import TextField from "@mui/material/TextField";
import {useTranslate} from "react-admin";
import {useEffect, useState} from "react";
import dataProvider from "../../components/dataProvider";
import {useNotify} from "react-admin";

const RevoIntegration = () => {
    const translate = useTranslate()
    const [selectedPosSetId, setSelectedPosSetId] = useState(0)
    const [cupPrice, setCupPrice] = useState(0)
    const [revoEnabled, setRevoEnabled] = useState(false)
    const notify = useNotify()

    useEffect(
        () => {
            if (selectedPosSetId && selectedPosSetId !== "undefined" && parseInt(selectedPosSetId) !== 0) {
                localStorage.setItem("revoPosSetId", selectedPosSetId)
               dataProvider.get('revo/revo-integration', {companyId: selectedPosSetId})
                    .then(value => {
                        setCupPrice(value.data.cupPrice)
                        setRevoEnabled(value.data.revoEnabled)
                    })
                    .catch(() => {
                        notify(translate("revo.error"))
                    })
            }
        }
    , [selectedPosSetId])
    const sendData = () => {
        const data = {
            companyId: selectedPosSetId,
            cupPrice: cupPrice,
            revoEnabled: revoEnabled
        }
        dataProvider.update('revo/revo-integration', data)
            .then(() => {
                notify(translate("revo.success"))
            })
            .catch(() => {
                notify(translate("revo.error"))
            })
    }

    return (
        <>
            <SelectCompanyWithBusinessUnitInput getResource={"revo"} setPosSet={setSelectedPosSetId} onlyCompany/>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                <TextField label={translate('revo.price')} variant="standard" sx={{width: '300px'}} value={cupPrice}
                           onChange={(event) => {
                               if (!/^\d*$/.test(event.target.value)) {
                                   return;
                               }
                               setCupPrice(event.target.value);
                           }}
                />
                <FormControlLabel control={<Checkbox checked={revoEnabled} onChange={
                    (event) => {
                        setRevoEnabled(event.target.checked)
                    }
                }/>} label={translate("revo.enable")}/>
                <Button sx={{width: '100px'}} onClick={sendData} variant="contained" color={"secondary"}>{translate("revo.save")}</Button>
            </Box>
        </>
    );
}
export default RevoIntegration;